// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2wPql","content":"GlobalSearch_content__R3BGF"};